<template>
  <div id="app">
    <div id="content">
      <!-- component matched by the route renders below -->
      <router-view/>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  components: {
    Header,
    Footer
  }
};
</script>

<style scoped lang="scss">
#app {
}

#content {
  padding: 4rem 2rem 2rem 2rem;
}
</style>
